import { isNil } from 'lodash'

export const isUndefinedOrNull = (value?: any) => isNil(value)
